import { buildConsentUpdate } from './buildConsentUpdate';

type GtagFn = (...args: unknown[]) => void;

interface WindowWithGtag extends Window {
    gtag?: GtagFn;
    dataLayer?: unknown[];
}

export const updateGtagConsent = (categories: readonly string[]) => {
    if (typeof window === 'undefined') {
        return;
    }

    const w = window as WindowWithGtag;
    const signals = buildConsentUpdate(categories);

    w.gtag?.('consent', 'update', signals);

    w.dataLayer = w.dataLayer ?? [];
    w.dataLayer.push({
        event: 'cookie_consent_update',
        consent_categories: categories,
    });
};
